import { createElement, FC } from 'react';
import { Radio } from 'legos/radio';
import { Field } from 'react-final-form';

export interface RadioFieldProps {
  /**
   * Set the radio button to disabled. Changes the look and color and makes the onClick not fire
   * @default false
   */
  disabled?: boolean;
  /**
   * value for current option
   */
  value: string;
  /**
   * name for current option
   */
  name: string;
  /**
   * sets required for current option
   */
  required?: boolean;
}

const requiredValidator = (value: string) => (value ? undefined : 'required');

export const RadioField: FC<RadioFieldProps> = ({
  name,
  value,
  children,
  required,
  disabled
}) => (
  <Field
    name={name}
    type="radio"
    validate={required ? requiredValidator : undefined}
    value={value}
  >
    {({ input, meta }) => {
      return (
        <Radio
          {...input}
          disabled={!!(disabled || meta.submitting)}
          error={meta.touched && meta.error}
          required={required}
        >
          {children}
        </Radio>
      );
    }}
  </Field>
);
